import { createContext, useContext, useEffect, useState } from "react";

import DataLoader from "../components/Data-Loader";

import { getItemFromSessionStore, removeItemFromSessionStore, setItemToSessionStore } from "../utils/storage.util";

const ProjectContext = createContext();

export function ProjectContextProvider({ children }) {

  const [userInfo, setUserInfo] = useState(null);
  const [isStimuliProcessing, setIsStimuliProcessing] = useState(false);
  const [projectId, setProjectId] = useState("");
  const [projectName, setProjectName] = useState("");
  const [brand, setBrand] = useState("");
  const [projectDescription, setProjectDescription] = useState("");
  const [productName, setProductName] = useState("");
  const [productURL, setProductURL] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [market, setMarket] = useState("")
  const [brandGuidelines, setBrandGuidelines] = useState("");
  const [brandInsights, setBrandInsights] = useState("");
  const [competition, setCompetition] = useState([]);
  const [brandGuidelineFile, setBrandGuidelineFile] = useState(null);
  const [runId, setRunId] = useState(() => {
    return getItemFromSessionStore('project_runId') || null;
  });
  const [personas, setPersonas] = useState([]);
  const [personaId, setPersonaId] = useState("");
  const [winningProduct, setWinningProduct] = useState("");

  const [draftedPersonas, setDraftedPersonas] = useState([]);

  const [selectedPersonas, setSelectedPersonas] = useState([]);

  const [isLoading, setIsLoading] = useState(false);


  // // Update sessionStorage whenever runId changes
  useEffect(() => {
    if (runId) {
      setItemToSessionStore('project_runId', runId);
    }
  }, [runId]);

  // Wrapper for setRunId to ensure both state and storage are updated
  const updateRunId = (newRunId) => {
    setRunId(newRunId);
    if (newRunId) {
      setItemToSessionStore('project_runId', newRunId);
    } else {
      removeItemFromSessionStore('project_runId');
    }
  };

  const providerValue = {
    userInfo,
    setUserInfo,
    isStimuliProcessing,
    setIsStimuliProcessing,
    projectId,
    setProjectId,
    projectName,
    setProjectName,
    projectDescription,
    setProjectDescription,
    productName,
    setProductName,
    productURL,
    setProductURL,
    productCategory,
    setProductCategory,
    market,
    setMarket,
    brandGuidelines,
    setBrandGuidelines,
    brandInsights,
    setBrandInsights,
    competition,
    setCompetition,
    brandGuidelineFile,
    setBrandGuidelineFile,
    runId,
    setRunId: updateRunId,
    personas,
    setPersonas,
    personaId,
    setPersonaId,
    winningProduct,
    setWinningProduct,

    draftedPersonas,
    setDraftedPersonas,

    selectedPersonas,
    setSelectedPersonas,

    brand,
    setBrand,
   
  };

  if (isLoading) {
    return <DataLoader />;
  }

  return (
    <ProjectContext.Provider value={providerValue}>
      {children}
    </ProjectContext.Provider>
  );
}

export const useProject = () => useContext(ProjectContext);
